var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "flex gap-2 flex-wrap text-sm font-normal" },
    [
      _vm._l(_vm.chipWithLinkDatas, function (chipWithLinkData, index) {
        return _vm.limit <= 0 || index < _vm.limit
          ? _c("Chip", {
              key: index,
              attrs: {
                variant: chipWithLinkData.variant,
                chipLink: chipWithLinkData.chipLink,
                chipData: chipWithLinkData.chipData,
                avatar: chipWithLinkData.avatar,
                chipText: chipWithLinkData.chipText,
                wrapChip: _vm.wrapChips,
              },
            })
          : _vm._e()
      }),
      _vm.limit <= 0 && _vm.extra > 0
        ? _c(
            "span",
            {
              staticClass: "font-normal text-base py-1 px-4 rounded-full",
              class:
                _vm.variant === "green"
                  ? "bg-badgeGreen text-skillGreen"
                  : _vm.variant === "blue"
                  ? "bg-lightBlue text-badgeBlue"
                  : "bg-gray-300 text-gray-800",
            },
            [_vm._v("+" + _vm._s(_vm.extra))]
          )
        : _vm._e(),
      !_vm.chipWithLinkDatas.length ? _c("span", [_vm._v("N/A")]) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }